import { ConsumerType } from './consumer.types';

const NOT_SPECIFIED = 'Not specified';

const consumerTypeLabels: Record<ConsumerType, string> = {
  CONSUMER_B2C: 'B2C',
  CONSUMER_B2B: 'B2B',
  CONSUMER_UNSPECIFIED: NOT_SPECIFIED,
};

export const formatConsumerType = (consumerType: ConsumerType | undefined) => {
  if (!consumerType) {
    return NOT_SPECIFIED;
  }
  return consumerTypeLabels[consumerType] ?? consumerType;
};

export const formatLangId = (langId: string | undefined) => {
  if (!langId || langId.trim() === '') {
    return NOT_SPECIFIED;
  }
  return langId.trim().toUpperCase();
};
